module.exports = __webpack_public_path__ + "img/image04.c785b774.jpg";